import * as Sentry from "@sentry/react";

export class Logger {
  public static error(error: unknown, message?: string) {
    if (message) {
      Sentry.captureMessage(message);
    }
    Sentry.captureException(error);
  }
}
